export const bodyStr =
	`<div id="main"></div>
	<div id="loading-text"></div>
		<div class="back-btn" id="stage_back_btn"></div>

`;


// WEBPACK FOOTER //
// ./src/stage/body.js